export var SIZE = {
  Full: 'full',
  Auto: 'auto'
};
export var MODE = {
  Regular: 'regular',
  Aggressive: 'aggressive',
  Forced: 'forced'
};
export var ALIGN = {
  Default: 'default',
  Center: 'center',
  Vertical: 'vertical'
};
export var CONTENT_ALIGN = {
  Default: 'default',
  Center: 'center'
};
export var TEST_IDS = {
  overlay: 'modal__overlay',
  closeButton: 'modal__close-button',
  header: 'modal__header',
  title: 'modal__title',
  subtitle: 'modal__subtitle',
  tooltip: 'modal__title-tooltip',
  icon: 'modal__icon',
  image: 'modal__image',
  content: 'modal__body',
  footer: 'modal__footer',
  approveButton: 'modal__approve-button',
  cancelButton: 'modal__cancel-button',
  additionalButton: 'modal__additional-button',
  disclaimer: 'modal__disclaimer',
  disclaimerText: 'modal__disclaimer-text',
  disclaimerLink: 'modal__disclaimer-link'
};